import * as React from 'react'
import { styleguide } from 'styleguide'

export default props => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 127 114"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <defs>
      <circle id="api-path-1" cx="109.5" cy="38.5" r="38.5" />
      <pattern
        id="api-pattern-2"
        width="36.841299"
        height="36.841299"
        x="34.158701"
        y="-36.841299"
        patternUnits="userSpaceOnUse">
        <use
          xlinkHref="#api-image-3"
          transform="scale(0.36841299,0.36841299)"
        />
      </pattern>
      <image
        id="api-image-3"
        width="100"
        height="100"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
    <g
      id="api-Desktop-Copy-3"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g id="api-Group-49" transform="translate(-21.000000, 0.000000)">
        <g id="api-Group-33">
          <g id="api-Oval-7">
            <use
              fill={styleguide.colors.illustrationLightBlue}
              xlinkHref="#api-path-1"
            />
            <use fill="url(#api-pattern-2)" xlinkHref="#api-path-1" />
          </g>
          <g
            id="api-Group-24-Copy"
            transform="translate(59.460324, 78.213510) rotate(-75.000000) translate(-59.460324, -78.213510) translate(18.960324, 27.713510)"
            stroke={styleguide.colors.illustrationStroke}
            stroke-width="1.25">
            <path
              d="M73.853194,68.9716716 C73.853194,43.3956129 53.3329235,22.6621207 28.019887,22.6621207 C12.897372,22.6621207 -0.514553643,30.0621257 -8.86238328,41.4737838"
              id="api-Oval-6"
              transform="translate(32.495405, 45.816896) rotate(-76.000000) translate(-32.495405, -45.816896) "
            />
            <path
              d="M72.8684848,107.398746 C72.8684848,99.9719796 71.0975885,92.9483762 67.9449385,86.7072443"
              id="api-Oval-6"
              transform="translate(70.406712, 97.052995) rotate(82.000000) translate(-70.406712, -97.052995) "
            />
            <path
              d="M27.4594814,97.2989093 C27.4594814,93.9187021 27.0056451,90.6223259 26.1435336,87.4458133"
              id="api-Oval-6"
              transform="translate(26.801508, 92.372361) rotate(131.000000) translate(-26.801508, -92.372361) "
            />
          </g>
        </g>
        <g
          id="api-Group-47"
          transform="translate(22.000000, 74.000000)"
          fill={styleguide.colors.illustrationMarl}>
          <g id="api-Group-46">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(10.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(20.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(30.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(40.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(50.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(60.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(70.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(80.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(90.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(100.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
          <g id="api-Group-46" transform="translate(110.000000, 0.000000)">
            <circle id="api-Oval-8" cx="3.5" cy="3.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="13.5" r="3.5" />
            <circle id="api-Oval-8" cx="3.5" cy="23.5" r="3.5" />
          </g>
        </g>
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Sections/HowItWorks/Background/ApiSvg.jsx